// Central site content. Contact details are placeholders — replace bracketed values.
export const TAGLINE = "Intelligent Living. Beautifully Designed.";

export const CONTACT = {
  phone: "(323) 471-4340",
  phoneHref: "tel:+13234714340",
  email: "info@integratedsolutionsav.com",
  license: "1152030",
  serviceAreas: ["Santa Barbara County", "Los Angeles County", "Orange County", "Palm Desert"],
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Portfolio", to: "/portfolio" },
  { label: "About", to: "/about" },
  { label: "Builders & Designers", to: "/builders-designers" },
  { label: "Care & Support", to: "/care-support" },
  { label: "Contact", to: "/contact" },
];

export const IMAGES = {
  heroMansion: "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  mansionPool: "https://images.unsplash.com/photo-1707189856923-46dd41ea2bdc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  mansionDusk: "https://images.unsplash.com/photo-1757356657991-c3fd6e2e812e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  theaterRed: "https://images.unsplash.com/photo-1710131459450-7c384b8be18f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  theaterScreen: "https://images.unsplash.com/photo-1665827491321-ce05d75c6a32?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  theaterAmbient: "https://images.unsplash.com/photo-1724061409979-420a38c25bcc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  livingWindow: "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  livingNight: "https://images.unsplash.com/photo-1666585607888-3f6fe0b323d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  bedroom: "https://images.unsplash.com/photo-1663811397207-418a92396ad5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  chaise: "https://images.unsplash.com/photo-1564078516393-cf04bd966897?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  poolRoom: "https://images.unsplash.com/photo-1529290130-4ca3753253ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  malibuEstate: "/malibu-estate.webp",
};

export const PARTNERS = ["Control4", "Josh.ai", "Lutron", "Sonos"];

export const BUDGETS = ["$25k – $50k", "$50k – $100k", "$100k – $250k", "$250k+"];

export const PLANS = [
  {
    name: "Essential",
    tagline: "Always-on peace of mind.",
    featured: false,
    features: [
      "Off-site device reboots during business hours",
      "Access to a 24/7 after-hours tech support line",
    ],
  },
  {
    name: "Premier",
    tagline: "Proactive care for the connected home.",
    featured: true,
    features: [
      "Proactive device monitoring & reboot services",
      "Access to a 24/7 after-hours tech support line",
      "One annual on-site system health check visit",
    ],
  },
  {
    name: "Signature",
    tagline: "White-glove service for the finest homes.",
    featured: false,
    features: [
      "Proactive device monitoring & reboot services",
      "Access to a 24/7 after-hours tech support line",
      "Four annual on-site system health check visits",
      "Two annual pre / post-event readiness checks",
      "Member service labor rates",
      "Priority service with faster response times",
    ],
  },
];

export const SERVICES = [
  {
    slug: "home-automation",
    index: "01",
    title: "Home Automation",
    tagline: "One gesture. The entire residence responds.",
    summary:
      "Unified control of lighting, climate, audio, video, shades, and security from a single, intuitive interface — engineered to disappear into the architecture.",
    image: "livingWindow",
    primary: true,
    points: [
      "Whole-home scene control across every room and outdoor space",
      "Voice, touch, keypad, and mobile control that stays in sync",
      "Climate, energy, and pool/spa integration",
      "Reliable performance built on Control4 and Josh.ai platforms",
    ],
  },
  {
    slug: "architectural-lighting-window-treatments",
    index: "02",
    title: "Architectural Lighting & Window Treatments",
    tagline: "Light as a material. Shade as a discipline.",
    summary:
      "Tunable, layered lighting and motorized window treatments that follow the sun, protect interiors, and set the mood — designed alongside your architect and designer.",
    image: "poolRoom",
    primary: true,
    points: [
      "Tunable-white and circadian lighting scenes",
      "Motorized shades, drapery, and skylight treatments",
      "Daylight and astronomic-clock automation",
      "Lutron-grade fixtures, keypads, and control",
    ],
  },
  {
    slug: "custom-home-theater",
    index: "03",
    title: "Custom Home Theater Design",
    tagline: "A private cinema, purpose-built.",
    summary:
      "Reference-grade rooms with calibrated acoustics, immersive sound, and true-cinema projection — from dedicated theaters to elegant media lounges.",
    image: "theaterRed",
    primary: true,
    points: [
      "Acoustic design, treatment, and room calibration",
      "Immersive surround and reference projection systems",
      "Tiered seating, risers, and millwork coordination",
      "Sonos and premium audio integration throughout",
    ],
  },
  {
    slug: "networking-wifi",
    index: "04",
    title: "Networking & Wi-Fi",
    tagline: "The invisible foundation.",
    summary:
      "Enterprise-grade wired and wireless networks engineered for full-property coverage, so every device and scene performs flawlessly.",
    image: "mansionDusk",
    primary: false,
    points: [
      "Full-coverage, seamless-roaming Wi-Fi",
      "Structured cabling and equipment rack design",
      "Network monitoring and remote support",
    ],
  },
  {
    slug: "security-surveillance",
    index: "05",
    title: "Security & Surveillance",
    tagline: "Discreet, always watching.",
    summary:
      "High-resolution camera systems and monitoring designed to blend into the architecture while protecting what matters most.",
    image: "mansionPool",
    primary: false,
    points: [
      "4K surveillance with intelligent alerts",
      "Remote viewing across all properties",
      "Integrated with automation and access control",
    ],
  },
  {
    slug: "access-control",
    index: "06",
    title: "Access Control",
    tagline: "Effortless, secure entry.",
    summary:
      "Keyless entry, video intercom, and gate integration that let residents and staff move through the property with ease.",
    image: "bedroom",
    primary: false,
    points: [
      "Keyless and mobile-credential entry",
      "Video intercom and visitor management",
      "Gate, garage, and door automation",
    ],
  },
];

export const AUDIENCES = [
  {
    index: "01",
    key: "homeowner",
    title: "Luxury Homeowners",
    body:
      "Technology that feels like part of the home — quiet, reliable, and beautiful. One relationship for every system, with white-glove service long after installation.",
  },
  {
    index: "02",
    key: "builder",
    title: "Custom-Home Builders",
    body:
      "A low-voltage partner who reads plans, meets your schedule, and coordinates cleanly with every trade. Pre-wire done right the first time, documented, and future-ready.",
  },
  {
    index: "03",
    key: "designer",
    title: "Interior Designers",
    body:
      "Systems that respect your vision. We conceal the hardware, protect the finishes, and deliver keypads, shades, and fixtures that complement your palette.",
  },
];

export const PROJECTS = [
  { title: "Hillside Glass Residence", county: "Santa Barbara County", discipline: "Home Automation", image: "livingWindow", size: "tall" },
  { title: "Coastal Media Lounge", county: "Orange County", discipline: "Home Theater", image: "theaterRed", size: "wide" },
  { title: "Malibu Estate", county: "Los Angeles County", discipline: "Home Theater & Automation", image: "malibuEstate", size: "std" },
  { title: "Ocean Terrace", county: "Santa Barbara County", discipline: "Window Treatments", image: "poolRoom", size: "std" },
  { title: "Modern Ridge Retreat", county: "Los Angeles County", discipline: "Whole-Home Control", image: "livingNight", size: "wide" },
  { title: "Private Screening Room", county: "Orange County", discipline: "Home Theater", image: "theaterScreen", size: "tall" },
  { title: "Skyline Penthouse", county: "Los Angeles County", discipline: "Lighting & Shades", image: "chaise", size: "std" },
  { title: "Poolside Pavilion", county: "Orange County", discipline: "Networking & AV", image: "mansionPool", size: "std" },
  { title: "Desert Modern Estate", county: "Palm Desert", discipline: "Whole-Home Control", image: "mansionDusk", size: "std" },
];

export const PROCESS = [
  { step: "01", title: "Consultation", text: "We listen — to you, your architect, and your designer — and study the plans and vision." },
  { step: "02", title: "Design & Engineering", text: "Detailed system design, drawings, and documentation coordinated with every trade." },
  { step: "03", title: "Integration", text: "Precise pre-wire and installation, concealed and calibrated to reference standards." },
  { step: "04", title: "Ongoing Care", text: "Proactive monitoring and white-glove service for the life of the system." },
];
